import _ from "lodash";
import moment from "moment";
import Theme from "../../theme";

const FOOD_TYPE = ["Breakfast", "Fruit", "Lunch", "Snack", "Snacks", "Fruits"];
export const DISPLAY_TIME_FORMAT = "hh:mm a";
const INDIA_UTC_OFFSET_MINUTES = 330;

// MySQL DATE/DATETIME often arrives as ISO UTC (e.g. 2026-08-25T18:30:00.000Z
// for midnight IST on Aug 26). Parsing that with format "YYYY-MM-DD" takes the
// UTC calendar day and labels today's updates as yesterday.
export const toIndiaCalendarDate = (dateValue) => {
    if (dateValue == null || dateValue === "") return "";
    if (typeof dateValue === "string") {
        const trimmed = dateValue.trim();
        if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
            return trimmed;
        }
    }
    const parsed = moment(dateValue);
    if (!parsed.isValid()) return "";
    return parsed.utcOffset(INDIA_UTC_OFFSET_MINUTES).format("YYYY-MM-DD");
};

export const getIndiaCalendarToday = () =>
    moment().utcOffset(INDIA_UTC_OFFSET_MINUTES).format("YYYY-MM-DD");

const getTypes = item => {
    const isfood = FOOD_TYPE.indexOf(item.type);

    //const isToday = item.date == moment().format("YYYY-MM-DD") ? true : false;

    let type = isfood >= 0 ? "food" : item.type ? item.type.toLowerCase() : "";
    let navigationParams = "";
    let dotColor = "";

    let navigateTo = "";
    let label = "";
    let linkImg = "";
    //let linkImg = require("../../../assets/foodMenu/Lunch.png");
    switch (type) {
        case "food":
            dotColor = Theme.colorPrimary;
            navigateTo = "FoodMenu";
            label = "Food Menu";
            // linkImg = require("../../assets/foodMenu/Lunch.png");
            break;
        case "milk":
            dotColor = Theme.colorPrimary;

            label = "Milk";
            // linkImg = require("../../assets/timeline/Milk-icon.png");
            break;
        case "image":
        case "photo":
            dotColor = Theme.colorPrimary;
            navigateTo = "PhotoGallery";
            label = "View Pics";
            // linkImg = require("../../assets/timeline/image-icon.png");
            break;
        case "message":
            dotColor = Theme.colorPrimary;
            navigateTo = "chat";
            label = "Message";

            // linkImg = require("../../assets/timeline/message-icon.png");
            break;
        case "measurement":
            dotColor = Theme.colorPrimary;
            navigateTo = "Growth";
            label = "Measurement";
            // linkImg = require("../../assets/timeline/measurement-icon.png");
            break;
        case "cor":
            dotColor = Theme.colorPrimary;
            navigateTo = "Growth";
            navigationParams = { activeTab: "COR" };
            label = "COR";
            // linkImg = require("../../assets/timeline/report-icon.png");
            break;
        case "attendance":
            dotColor = Theme.colorPrimary;
            navigateTo = "attendance";


            label = "Attendance";
            // linkImg = require("../../assets/timeline/attendance-icon.png");
            break;
        case "activity":
            dotColor = Theme.colorPrimary;


            //navigateTo = 'ActivityCalendar';
            label = "Activity";
            // linkImg = require("../../assets/timeline/activity-icon.png");
            break;
        case "outdoorevents":
            dotColor = Theme.colorPrimary;
            navigateTo = "OutdoorActivity";
            label = "OutdoorEvents";
            // linkImg = require("../../assets/timeline/outdoor.png");
            break;
        default:
            // dotColor = 'yellow';
            dotColor = Theme.colorPrimary;


    }

    return {
        dotColor,
        navigateTo,
        label,
        linkImg,
        navigationParams
    };
};

export const transform = timeLineItem => {
    if (Array.isArray(timeLineItem) && timeLineItem.length > 0) {
        return timeLineItem.map(item => {
            const momentTime = moment(item.time, ["HH:mm:ss", "hh:mm:ss"], true);
            return {
                ...item,
                time: momentTime.format(DISPLAY_TIME_FORMAT),
                momentTime,
                ...getTypes(item)
            };
        });
    }
    return [];
};

export const transformTimeLine = (timeline, useDateFormat = true) => {
    try {
        if (Array.isArray(timeline)) {
            let dateGroup = _.groupBy(timeline, d => {
                const calendarDate = toIndiaCalendarDate(d.date);
                if (calendarDate) {
                    return moment(calendarDate, "YYYY-MM-DD").format("DD-MM-YY");
                }
                if (useDateFormat) {
                    return moment(d.date, "YYYY-MM-DD").format("DD-MM-YY");
                }
                return moment(d.date).format("DD-MM-YY");
            });
            dateGroup = _.reduce(
                dateGroup,
                (acc, next, index) => {
                    acc.push({
                        dateGroup: index,
                        data: transform(next)
                    });
                    return acc;
                },
                []
            );
            return dateGroup;
        }
        return [];
    } catch (error) {
        return [];
    }
};
